<template>
  <el-dialog class="x-upload-dialog" width="570" height="300" ref="dialog" :title="title" v-bind="$attrs" v-on="$listeners"
             :append-to-body="appendToBody" :modal-append-to-body="modalAppendToBody" :resizable="false" :multiple="true"
             :maximizable="false" :closable="false">
    <div class="x-upload-dialog-body">
      <div class="x-upload-wrapper">
        <x-upload ref="upload" v-bind="$attrs" v-on="$listeners">
          <template v-slot:topTip>
            <slot name="topTip"></slot>
          </template>
        </x-upload>
      </div>
      <div class="x-upload-dialog-btn-container">
        <el-button type="primary" @click="handleConfirm" v-show="$attrs.disabled !== true">确定</el-button>
        <el-button @click="handleClose">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'XUploadDialog',
  inheritAttrs: false,
  props: {
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '上传文件'
    },
    convertUploadFiles: Function
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    handleConfirm() {
      const uploadFiles = this.$refs.upload.uploadFiles;
      if (!Array.isArray(uploadFiles) || !this.convertUploadFiles) {
        return;
      }
      for (const file of uploadFiles) {
        if (file.status === 'uploading') {
          this.$notify.error('文件上传中');
          return;
        }
      }
      // 点击确定时，调用父组件传入的处理函数
      this.convertUploadFiles({uploadFiles});
      this.handleClose();
    }
  }
};
</script>
<style lang="scss">
.x-upload-dialog-body {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.x-upload-wrapper {
  flex: 1 0 0;
}
.x-upload-dialog-btn-container {
  flex: 0 0 auto;
  text-align: right;
}
</style>